import React from 'react';

// The health score is currently mocked (see MockExtrasGenerator). Until the real
// composite score ships, the score *displays* are shown disabled with this
// tooltip. Single source of truth so every surface reads identically.
export const HEALTH_IN_PROGRESS = 'In Progress';

// Neutral grey used for the disabled (in-progress) dot.
export const HEALTH_DISABLED_DOT = '#C7C5BC';

export function healthColor(score) {
  if (score < 50) return { dot: '#9B1F26', text: '#7C1A20' };
  if (score < 75) return { dot: '#B86E1D', text: '#7E4C16' };
  return { dot: '#1F6B41', text: '#16502F' };
}

export default function HealthDot({ score, size = 9, disabled = false }) {
  const background = disabled ? HEALTH_DISABLED_DOT : healthColor(score).dot;
  return (
    <span
      style={{
        display: 'inline-block',
        width: size, height: size,
        borderRadius: '50%',
        background
      }}
    />
  );
}
